import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AccountService } from '@app/core/services/account.service';
import { LoggingService } from '@app/core/services/logging.service';
import { UnityDirectStateService } from '@app/core/services/unity-direct-state.service';
import { UserInfoService } from '@app/core/services/user-info.service';
import { IAccountData } from '@app/models/account-data.model';
import { Pages } from '@app/models/Pages';
import { IUserAccMarketPlace } from '@app/models/user-info.model';
import { Observable, of } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CanActivateBundlesPage implements CanActivate {
  constructor(
    private accountService: AccountService,
    private udStateService: UnityDirectStateService,
    private userInfoService: UserInfoService,
    private router: Router,
    private ls: LoggingService
  ) {}

  canActivate(): Observable<boolean> {
    return this.userInfoService.getUserInfo().pipe(
      concatMap((userInfo: IUserAccMarketPlace) => {
        const userAccountIndex = this.userInfoService.getAccountIndex(userInfo);
        /* check if cookie set or not*/
        if (userAccountIndex >= 0) {
          this.udStateService.userInfo = userInfo[userAccountIndex];
          return this.accountService.getAccount(userInfo[userAccountIndex]);
        }
        this.udStateService.userInfo = userInfo[0];
        return this.accountService.getAccount(userInfo[0]);
      }),
      concatMap((accountInfo: IAccountData) => {
        this.udStateService.userAccount = accountInfo;
        if (accountInfo.isBundleEnabled) {
          return of(true);
        } else {
          this.router.navigate([Pages.Review]); // redirect to Review page (Review resolver will decide navigation between Review page and Worksheet)
        }
      }),
      catchError(() => {
        this.router.navigate([Pages.Error]);
        this.ls.sendErrorLevelMessage('Bundles Page Resolver Error', this, {
          error: 'There was an error completing the bundles page resolver.'
        });
        return of(null);
      })
    );
  }
}
